import type { Middleware } from '@ulysses-inc/harami_api_client'
import { getHaramiMockApiEndpoints } from 'src/config'

/**
 * `getHaramiMockApiEndpoints()` のパスマッチで URL を mock サーバー宛てに差し替える純関数。
 * `baseClient` 経由以外 (生 `fetch` 等) でも mock 差し替えを噛ませるために export している。
 */
export const applyMockServerRewrite = (params: {
  url: string
  init: RequestInit
}): { url: string; init: RequestInit } => {
  const { url, init } = params
  const mockEndpoints = getHaramiMockApiEndpoints()
  if (mockEndpoints.length === 0) {
    return { url, init }
  }
  const originalUrl = new URL(url)
  for (const mockEndpoint of mockEndpoints) {
    if (new URL(mockEndpoint).pathname === originalUrl.pathname) {
      return {
        url: mockEndpoint + originalUrl.search,
        init: {
          ...init,
          headers: {
            ...(init.headers ?? {}),
            'X-API-KEY': 'dummy',
          },
        },
      }
    }
  }
  return { url, init }
}

const mockServerMiddleware: Middleware['pre'] = async ({ url, init }) =>
  applyMockServerRewrite({ url, init })

const preMiddlewaresBase: Middleware['pre'][] = []

const mockApiEndpoints = getHaramiMockApiEndpoints()
if (mockApiEndpoints.length > 0) {
  preMiddlewaresBase.push(mockServerMiddleware)
}

export const preMiddlewares: readonly Middleware['pre'][] = [
  ...preMiddlewaresBase,
]
